import TaskCell from './TaskCell'

export { TaskCell } from './TaskCell'
export default TaskCell;


// WEBPACK FOOTER //
// ./src/components/CalendarView/CalendarCell/TaskCell/index.js